import { render, staticRenderFns } from "./BusinessGuideMobileDropdown.vue?vue&type=template&id=6352c849&scoped=true"
import script from "./BusinessGuideMobileDropdown.vue?vue&type=script&lang=js"
export * from "./BusinessGuideMobileDropdown.vue?vue&type=script&lang=js"
import style0 from "./BusinessGuideMobileDropdown.vue?vue&type=style&index=0&id=6352c849&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6352c849",
  null
  
)

export default component.exports